/**
 * Redirects to our website with the provided url.
 * If 'entities/1', it redirects to 'domain:8000/entities/1'.
 *
 * @param url
 * @param params
 */
export function goTo(url, params = null) {
    if (url.startsWith('/')) {
        url = url.substring(1);
    }

    url += buildUrlQueryParams(params);

    window.location.href = window.location.origin + '/' + url;
}

/**
 * Fires a request to a url that must force navigator to download a file.
 *
 * @param url Url (maybe with params) that forces the download
 * @param params
 * @param filename
 */
export function downloadFromUrl(url, params = null, filename = 'download.xlsx') {
    if (url.startsWith('/')) {
        url = url.substring(1);
    }

    url += buildUrlQueryParams(params);

    if (!filename.endsWith('.xlsx')) {
        filename += '.xlsx';
    }

    axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

/**
 * Gets a params array and pushes them into an url query params. Returns it as ?param1=value1&param2=value2.
 *
 * @param params
 * @returns {string}
 */
export function buildUrlQueryParams(params = null) {
    let url = '';

    if (params !== null && params !== {}) {
        let one_param_at_least = false;
        for (let i in params) {
            if (params[i] !== '' && params[i] !== null) {
                if (one_param_at_least === false) {
                    url += '?';
                    one_param_at_least = true;
                }

                url += i + '=' + params[i] + '&';
            }
        }

        if (one_param_at_least) {
            url = url.slice(0, -1);
        }
    }

    return url;
}

export function getHummanSize(size) {
    size = parseInt(size);
    let $units = ['B', 'KB', 'MB', 'GB', 'TB'];

    if (size === 0) {
        return '0 '.$units[1];
    }

    let $i = 0;

    for ($i; size > 1024; $i++) {
        size /= 1024;
    }

    return size.toFixed(2) + ' ' + $units[$i];
}
